/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import * as React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { SegmentedControl as MantineSegmentedControl } from '@mantine/core';
import { useTheme } from 'styled-components';
import type { SegmentedControlItem } from '@mantine/core';

type Props = {
  data: Array<string> | Array<SegmentedControlItem>,
  defaultValue?: string,
  disabled?: boolean,
  handleChange?: (value: string) => void | Dispatch<SetStateAction<string>>,
  value?: string,
}

const SegmentedControl = ({ data, defaultValue, disabled, handleChange, value }: Props) => {
  const theme = useTheme();

  return (
    <MantineSegmentedControl color={theme.colors.variant.info}
                             data={data}
                             defaultValue={defaultValue}
                             disabled={disabled}
                             value={value}
                             onChange={handleChange}
                             styles={{ label: { marginBottom: 0 } }} />
  );
};

SegmentedControl.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  handleChange: undefined,
  value: undefined,
};

export default SegmentedControl;
